import React from "react";
import {StringList} from "../components";

export const renderTable = (
  block: any
) => {
  return (
    <div
      className="overflow-x-auto">
      <table
        className="table-auto w-full border border-custom-gray-500 text-left">
        {block.heading && block.heading.length > 0 && (
          <thead className="bg-gray-light dark:bg-gray-dark">
            <tr
              className="">
              {block.heading.map((head: any, hIdx: number) => (
                <th
                  key={hIdx}
                  className="px-4 py-2 text-sm md:text-md font-bold leading-normal text-custom-gray-700 dark:text-ghost-white border border-custom-gray-500 align-top"
                >
                  {head}
                </th>
              ))}
            </tr>
          </thead>
        )}

        {block.rows && block.rows.length > 0 && (
          <tbody>
            {block.rows.map((row: any, rIdx: number) => (
              <tr
                key={rIdx}>
                {row.map((cell: any, cIdx: number) => (
                  <td
                    key={cIdx}
                    className="w-fit px-4 py-2 text-sm md:text-md font-normal leading-normal text-custom-gray-600 dark:text-pale-white border border-custom-gray-500 align-top"
                  >
                    {typeof cell === 'string' ? (
                      cell
                    ) : cell && typeof cell === 'object' ? (
                      <div className="flex flex-col gap-2">
                        {cell.stringList && (
                          <StringList items={cell.stringList} />
                        )}
                        {(cell.type === 'paragraph' || cell.text || cell.paragraph) && (
                          <p className="text-sm md:text-md font-normal leading-normal text-custom-gray-600 dark:text-pale-white">
                            {cell.text || cell.content || (typeof cell.paragraph === 'object' ? cell.paragraph?.text || cell.paragraph?.content : cell.paragraph)}
                          </p>
                        )}
                      </div>
                    ) : null}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        )}
      </table>
    </div>
  )
};